import React, { useState } from "react";
import "./updatePasswordAccount.scss";
import Close from "@mui/icons-material/Close";
import {
  ManageAccounts,
  VisibilityOff,
  VisibilityOutlined,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import toast, { LoaderIcon } from "react-hot-toast";
import { requestType, UserType } from "../../../../types/GlobalType";
import { accountService } from "../../../../_services/accountServices";
import user_api from "../../../../apiCaller/user.Caller";
import { catchErrorApiCall } from "../../../../_services/apiUtils";
import ErrorBar from "../../../../component/errorComp/ErrorBar.tsx";

type Props = {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  data: UserType | undefined;
  setOpen2: React.Dispatch<React.SetStateAction<Boolean>>;
  // dispatchReload: () => void;
};
const UpdatePasswordAccount = (props: Props) => {
  const [pswd, setpswd] = useState<string>("");
  const [errorMsg] = useState<string>("");
  const [visible, setVisible] = useState<boolean>(false);
  const [type, setType] = useState<string>("password");
  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: null,
  });

  const navigate = useNavigate();

  const handleUpdate = async () => {
    if (!pswd?.toString().length) {
      return setState({
        ...state,
        errorMessage: "Veuiller compléter le mot de passe",
      });
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();
    if (!token) return navigate("/login");

    let userId = accountService.getUserImei();
    if (!userId) return navigate("/login");

    try {
      let id = props.data?.user_id;
      let data = { password: pswd };

      const response = await user_api.updatePassword(id, data, token);
      // console.log(response);
      if (response.data.status === 200 || response.data.status === 201) {
        toast.success("Mis à jour effectuée avec succes", {
          duration: 4000,
          style: {
            zIndex: 9999,
          },
        });
        setpswd("");
        // props.dispatchReload();
        props.setOpen(false);
        // props.setOpen2(false);
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
            zIndex: 9999,
          },
        });
      }
    } catch (error) {
      // console.log(error);
      catchErrorApiCall(error);
    } finally {
      setState({ ...state, isLoading: false });
      props.setOpen(false);
      props.setOpen2(false);
    }
  };

  return (
    <>
      <div className="update_pswd">
        <div className="dialogP">
          <div className="header_pswd">
            <div className="header_left">
              <ManageAccounts />
              {"Nouveau mot de passe"}
            </div>
            {state.isLoading ? (
              <Close className="ico_close" />
            ) : (
              <Close
                className="ico_close"
                onClick={() => props.setOpen(false)}
              />
            )}
          </div>
          {!!errorMsg && <ErrorBar title={errorMsg} />}
          <div className="body">
            {state.errorMessage && <ErrorBar title={state.errorMessage} />}
            <div className="itemsP">
              {/* <div className="itemP">
                <span>Email *</span>
                <span>Witeesdras@gmail.com</span>
              </div> */}

              <div className="itemP">
                {/* <span>Nouveau mot de passe *</span> */}
                <div className="inputContainerP">
                  <input
                    type={type}
                    placeholder={"*************************"}
                    value={pswd}
                    onChange={(e) => setpswd(e.target.value)}
                  />
                  {visible ? (
                    <VisibilityOutlined
                      className="icoPas"
                      onClick={() => {
                        setType("password");
                        setVisible(false);
                      }}
                    />
                  ) : (
                    <VisibilityOff
                      className="icoPas"
                      onClick={() => {
                        setType("text");
                        setVisible(true);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            {state.isLoading ? (
              <div className="btns">
                <button className="disabled">Annuler</button>
                <button className="waiting">
                  <LoaderIcon />
                  Enregistrement...
                </button>
              </div>
            ) : (
              <div className="btns">
                <button onClick={() => props.setOpen(false)}>Annuler</button>
                <button onClick={handleUpdate}>Enregistrer</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdatePasswordAccount;
